import { Routes } from '@angular/router';
import { GrundstueckSucheComponent } from './grundstueck-suche/grundstueck-suche.component';
import { GrundstueckSearchResultComponent } from './grundstueck-search-result/grundstueck-search-result.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { ErweiterungConfigResponse, PermissionResponse } from '../core/base-api';
import { GrundstueckDetailComponent } from './grundstueck-detail/grundstueck-detail.component';
import { GrundstueckGbAvRubrikComponent } from './grundstueck-rubriken/alle-rubrik/grundstueck-gb-av-rubrik.component';
import {
  GrundstueckUebersichtRubrikComponent
} from './grundstueck-rubriken/uebersicht-rubrik/grundstueck-uebersicht-rubrik.component';
import {
  GrundstueckDienstbarkeitenRubrikComponent
} from './grundstueck-rubriken/dienstbarkeiten-rubrik/grundstueck-dienstbarkeiten-rubrik.component';
import {
  GrundstueckbeschreibungRubrikComponent
} from './grundstueck-rubriken/beschreibung-rubrik/grundstueckbeschreibung-rubrik.component';
import {
  GrundstueckEigentumRubrikComponent
} from './grundstueck-rubriken/eigentum-rubrik/grundstueck-eigentum-rubrik.component';
import {
  GrundstueckGrundlastenRubrikComponent
} from './grundstueck-rubriken/grundlasten-rubrik/grundstueck-grundlasten-rubrik.component';
import {
  GrundstueckVormerkungenRubrikComponent
} from './grundstueck-rubriken/vormerkungen-rubrik/grundstueck-vormerkungen-rubrik.component';
import {
  GrundstueckAnmerkungenRubrikComponent
} from './grundstueck-rubriken/anmerkungen-rubrik/grundstueck-anmerkungen-rubrik.component';
import {
  GrundstueckGrundpfandrechteRubrikComponent
} from './grundstueck-rubriken/grundpfandrechte-rubrik/grundstueck-grundpfandrechte-rubrik.component';
import {
  GrundstueckHaengigeRubrikComponent
} from './grundstueck-rubriken/haengige-rubrik/grundstueck-haengige-rubrik.component';
import { GrundstueckGwrObjekteComponent } from './grundstueck-gwr-objekte/grundstueck-gwr-objekte.component';
import { GrundstueckNeskoabRubrikComponent } from './grundstueck-rubriken/neskoab-rubrik/neskoab-rubrik.component';
import {
  GrundstueckOerebRubrikComponent
} from './grundstueck-rubriken/oereb-rubrik/grundstueck-oereb-rubrik.component';
import {
  RangregelungenRubrikComponent
} from './grundstueck-rubriken/rangregelungen-rubrik/rangregelungen-rubrik.component';
import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { GrundstueckFormService } from './grundstueck-form-service';
import { GrundstueckRubrikService } from './grundstueck-rubriken/grundstueck-rubrik.service';
import { OerebStateService } from '../oereb/services/oereb-state.service';
import {
  AmtlicheBewertungDetailComponent
} from './beschreibung/amtliche-bewertung-stime/amtliche-bewertung-detail/amtliche-bewertung-detail.component';
import { canActivateErweiterung } from '../security/erweiterung.guard';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const GrundstueckRoutes: Routes = [
  {
    path: 'grundstueck',
    pathMatch: 'prefix',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN, PermissionsEnum.ICP_AUTHORIZED, PermissionsEnum.ANONYM]
    },
    children: [
      {
        path: '',
        loadChildren: () => routes,
        providers: [GrundstueckFormService, GrundstueckRubrikService, OerebStateService]
      }
    ]
  }
];

const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    component: GrundstueckSucheComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.GRUNDSTUECK_REGISTER],
      breadcrumb: 'grundstueck.search.breadcrumb',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/:searchMode',
    component: GrundstueckSearchResultComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.GRUNDSTUECK_REGISTER],
      breadcrumb: 'shared.breadcrumb.list',
      breadcrumbStatus: 'secondLevel'
    }
  },
  {
    path: 'detail',
    component: GrundstueckDetailComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN]
    },
    children: [
      {
        path: 'gbav',
        component: GrundstueckGbAvRubrikComponent
      },
      {
        path: 'uebersicht',
        component: GrundstueckUebersichtRubrikComponent
      },
      {
        path: 'dienstbarkeiten',
        component: GrundstueckDienstbarkeitenRubrikComponent
      },
      {
        path: 'rangregelungen',
        component: RangregelungenRubrikComponent
      },
      {
        path: 'beschreibung',
        component: GrundstueckbeschreibungRubrikComponent
      },
      {
        path: 'eigentum',
        component: GrundstueckEigentumRubrikComponent
      },
      {
        path: 'grundlasten',
        component: GrundstueckGrundlastenRubrikComponent
      },
      {
        path: 'vormerkungen',
        component: GrundstueckVormerkungenRubrikComponent
      },
      {
        path: 'anmerkungen',
        component: GrundstueckAnmerkungenRubrikComponent
      },
      {
        path: 'pfandrechte',
        component: GrundstueckGrundpfandrechteRubrikComponent
      },
      {
        path: 'haengige',
        component: GrundstueckHaengigeRubrikComponent
      },
      {
        path: 'gwrobjekte',
        component: GrundstueckGwrObjekteComponent
      },
      {
        path: 'oereb',
        component: GrundstueckOerebRubrikComponent
      },
      {
        path: 'neskoab',
        component: GrundstueckNeskoabRubrikComponent
      },
      {
        path: 'stime',
        canActivate: [canActivateAuthorization, canActivateErweiterung],
        data: {
          permissions: [PermissionsEnum.STIME_ANZEIGE_AMTLICHE_BEWERTUNG],
          erweiterung: [ActiveErweiterungenEnum.STIME_SCHNITTSTELLE]
        },
        component: AmtlicheBewertungDetailComponent
      },
      {
        path: '**',
        redirectTo: 'uebersicht',
        pathMatch: 'prefix'
      }
    ]
  }
];
